import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=b1745688&scoped=true&"
import script from "./Account.vue?vue&type=script&setup=true&lang=js&"
export * from "./Account.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1745688",
  null
  
)

export default component.exports